import { BookletList } from "@/@types/Booklet";
import { ApiClient } from "../../ApiClient";
import { GetBookletListResponse } from "../schema/GetBookletListResponse";
import { mapBookletList } from "../../mappers/booklets/bookletListMapper";

export const getBookletList = async (p0?: { page: string; }): Promise<BookletList> => {
    const client = ApiClient.getInstance();
  
    const pageParam = p0?.page || '1';
    const response = await client.get<GetBookletListResponse>(`booklets/list?page=${pageParam}`);
  
    const mappedResponse = mapBookletList(response);
  
    return mappedResponse;
  }
  